"use client"

import { PrivyProvider } from "@privy-io/react-auth"

const PRIVY_APP_ID = process.env.NEXT_PUBLIC_PRIVY_APP_ID

// Whether Privy is configured — gates the "Continue with Email" login option
// so the rest of the app works unchanged until an App ID is set.
export const PRIVY_ENABLED = !!PRIVY_APP_ID

export function PrivyAppProvider({ children }: { children: React.ReactNode }) {
  if (!PRIVY_APP_ID) {
    return <>{children}</>
  }

  return (
    <PrivyProvider
      appId={PRIVY_APP_ID}
      config={{
        loginMethods: ["email", "google", "twitter"],
        appearance: {
          theme: "dark",
          accentColor: "#25e4e8",
          walletChainType: "solana-only",
        },
        embeddedWallets: {
          solana: {
            // Only spin up an embedded wallet for users who log in via
            // Privy and don't already bring their own (Phantom/etc.) wallet.
            createOnLogin: "users-without-wallets",
          },
        },
      }}
    >
      {children}
    </PrivyProvider>
  )
}